
import { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { galleryProjects } from '../../../mocks/galleryProjects';
import GalleryFilter from './GalleryFilter';
import ProjectCard from './ProjectCard';

export default function GalleryGrid() {
  const [activeCategory, setActiveCategory] = useState('Wszystkie');

  const filteredProjects = useMemo(() => {
    if (activeCategory === 'Wszystkie') return galleryProjects;
    return galleryProjects.filter((p) => p.category === activeCategory);
  }, [activeCategory]);

  return (
    <section className="relative py-12 sm:py-16 lg:py-20 bg-[#050505]">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00E5FF]/20 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <GalleryFilter
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        <AnimatePresence mode="wait">
          <motion.div
            key={activeCategory}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8"
            style={{ perspective: '1500px' }}
          >
            {filteredProjects.map((project, index) => (
              <ProjectCard key={project.id} project={project} index={index} />
            ))}
          </motion.div>
        </AnimatePresence>

        {filteredProjects.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-16 sm:py-20"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mx-auto mb-4 sm:mb-6 border border-[#00E5FF]/20">
              <i className="ri-folder-open-line text-3xl sm:text-4xl text-[#00E5FF]/40"></i>
            </div>
            <p className="text-[#C0C7CF]/60 text-base sm:text-lg" style={{ fontFamily: 'Inter, sans-serif' }}>
              Brak realizacji w tej kategorii
            </p>
          </motion.div>
        )}
      </div>
    </section>
  );
}
